import { render, staticRenderFns } from "./Chips.vue?vue&type=template&id=bc33095c&"
import script from "./Chips.vue?vue&type=script&lang=js&"
export * from "./Chips.vue?vue&type=script&lang=js&"
import style0 from "./Chips.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports